import React, { useState, useEffect } from 'react';
import { FormGroup } from 'reactstrap';
import InputMask from 'react-input-mask';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';

export default function MoneyInput(props) {
  const { id, required, disabled, readonly, autofocus, onChange: onChangeForm, schema, formData: value } = props;
  const [current, setCurrent] = useState(value);
  const { title } = schema;

  useDebouncedEffect(
    () => {
      if (current !== value) {
        onChangeForm(parseFloat(current));
      }
    },
    [current],
    450
  );

  useEffect(() => setCurrent(value), [value]);

  const maskToCurrency = ({ nextState }) => {
    let { value } = nextState || {};

    value = value?.replace?.(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    console.log('print value', value);

    return {
      ...nextState,
      value,
    };
  };

  return (
    <FormGroup>
      <label className="control-label">{title}</label>
      <InputMask
        disabled={disabled}
        className="form-control"
        value={current || ''}
        required={required}
        beforeMaskedStateChange={maskToCurrency}
        onChange={e => setCurrent(e.target.value)}
        readOnly={readonly}
        autoFocus={autofocus}
        id={id}
      />
    </FormGroup>
  );
}
